$(document).ready(function () {
    $('#popin-informations').on('closed', function () {
        window.location = '/';
    });

    $('#popin-informations #infos').html('Votre demande a bien été transmise');

    var showPopinSuccess = $('#show-popin-confirm');
    if (showPopinSuccess != null && typeof (showPopinSuccess) != "undefined" && showPopinSuccess.length > 0) {
        $('#ajax-modal-small').foundation('reveal', 'open', {
            url: '/Contact/PopinConfirmationMessageEnvoye'
        });
    }

    $("#piece-jointe").on("change", function (e) {
        $(".piece-jointe-details").text($(this).val());
        if ($(this).val() != "") {
            $(".upload-button-title").html("Modifier ma pièce jointe");
            $(".supprimer-piece-jointe").show();
        }
        else {
            $(".upload-button-title").html("Insérer une pièce jointe");
            $(".supprimer-piece-jointe").hide();
        }
    });

    $(".supprimer-piece-jointe").on("click", function (e) {
        e.preventDefault();
        $(".upload-button-title").html("Insérer une pièce jointe");
        $("#piece-jointe").value = "";
        $(".piece-jointe-details").text("");
        $(this).hide();
    });

    $("#question").on("change", function (e) {
        if ($("#question").val() == "8") {
            window.location = '/demande-creation-speciale.html?t=' + encodeURIComponent($("#message").val());
        }
    });
});

function DisabledButton() {
    $('.save-contact').attr('disabled', 'disabled');
}